export const PORTAL_CODE = 'PurchasePortal';

export const PURCHASE_WIDGET_STYLES_BUNDLE_ID = 'wf-widget-styles';
